module.exports = __webpack_public_path__ + "static/lion2-5a8adc18c2249fc136cf58acac7353a8.png";